import { createFileRoute, type SearchSchemaInput } from '@tanstack/react-router';
import { artifactsQuery } from '@/services/artifacts';
import { myRoleQuery } from '@/services/team-members';
import { ArtifactsPage } from '@/features/artifacts/artifacts-page';
import { parseArtifactsSearch, type ArtifactsSearchInput } from '@/features/artifacts/search';

// Every artifact her role reaches (Kazzy, 12 Oct 2026: Content became Artifacts). Her role decides the kinds she sees.
export const Route = createFileRoute('/_authed/artifacts')({
  validateSearch: (search: ArtifactsSearchInput & SearchSchemaInput) => parseArtifactsSearch(search),
  loader: ({ context: { queryClient, team } }) =>
    team ? Promise.all([queryClient.ensureQueryData(artifactsQuery(team.id)), queryClient.ensureQueryData(myRoleQuery(team.id)).catch(() => null)]) : undefined,
  component: ArtifactsPage,
});
